import React from 'react';
import dcgLogo from '../../../assets/img/brand/dcg_logo_header.png';
import PortalAdminInfoPageContent from '../PageContent/PortalAdminInfoPageContent';
import { SectionDivider, PageTitle, HeaderAndBodyLayout } from '../../../utilities/dcgAutomationPageCommonImports';


const PortalAdminInfo = () => {
    return (
        <HeaderAndBodyLayout headerLogo={dcgLogo}>
            <PageTitle heading="Let's start building your Portal" subheading="The place to store and manage your data." />
            <SectionDivider width="70%" />
            <PortalAdminInfoPageContent />
        </HeaderAndBodyLayout>
    )
}
export default PortalAdminInfo;